function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#474747;stroke-width:2;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#474747;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "Path-4",
  className: "st0",
  d: "M8,47.2c-3.1-7-3.5-14.9-0.9-22.1c2.5-7.2,7.8-13,14.7-16.3c1.9-0.9,3.9-1.6,6-2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-5",
  className: "st1",
  points: "23.3,3.5 22.9,4.5 27.8,6.6 25.3,11.2 26.3,11.7 29.3,6.1  "
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-6",
  className: "st1",
  d: "M9.4,50.9c1.2-0.5,1.9-1.7,1.7-2.9s-1.4-2.1-2.7-2.1c-1.6,0.3-2.6,1.7-2.3,3.2 C6.4,50.3,7.9,51.2,9.4,50.9L9.4,50.9L9.4,50.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "Path-4_1_",
  className: "st0",
  d: "M43.5,7.5c7.4,1.6,13.9,6,18.1,12.3C65.9,26,67.4,33.7,66,41c-0.4,2-1.1,4-1.9,5.9"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-5_1_",
  className: "st1",
  points: "69.3,44.9 68.8,44 64.2,46.7 62,42 61,42.5 63.7,48.2  "
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-6_1_",
  className: "st1",
  d: "M39.8,6.5C39.5,7.8,40,9,41.1,9.6c1.1,0.5,2.4,0.1,3.2-0.9c0.6-1.5,0.1-3.1-1.2-3.7 C42,4.4,40.5,5.1,39.8,6.5C39.8,6.4,39.8,6.4,39.8,6.5L39.8,6.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "Path-4_2_",
  className: "st0",
  d: "M57.4,57.1c-4.7,5.6-11.4,9.2-18.7,10.1c-7.2,0.8-14.5-1.3-20.2-5.8c-1.6-1.3-3-2.7-4.2-4.3"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-5_2_",
  className: "st1",
  points: "13.4,62.3 14.4,62.3 14.1,57.2 19.1,57.4 19.1,56.4 13.1,56.1  "
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-6_2_",
  className: "st1",
  d: "M59.9,54.4c-1-0.8-2.3-0.9-3.2-0.2s-1.2,2-0.7,3.2c1,1.2,2.6,1.5,3.7,0.7 C60.7,57.2,60.8,55.6,59.9,54.4C60,54.5,60,54.5,59.9,54.4L59.9,54.4z"
})));

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.066b8526.svg";
export { ForwardRef as ReactComponent };